import React,{useRef} from 'react';
import { Menu } from 'primereact/menu';
import { Button } from "primereact/button"; // Para el botón de hamburguesa
import useLogout from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";

const Navbar = ({Auth }) => {
  // console.log(Auth); // Para verificar que se está recibiendo el objeto Auth correctamente
  const navigate = useNavigate();

  const logout = useLogout();

  const menuRight = useRef(null);

  const optionsUser = [
    {
      label: 'Perfil',
      icon: 'pi pi-user',
      command: () => navigate('/perfil'),
    },
    {
      label: 'Cerrar sesión',
      icon: 'pi pi-sign-out',
      command: () => {
         signOut();
      }
    }
  ];
const signOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    
 <div className="layout-topbar">
      <a className="app-logo" href="/">
        <img alt="app logo" src="/images/pago-en-linea.png" />
        <span className="app-name">Factura Web</span>
      </a>
      <ul className="topbar-menu">
        <li className="topbar-menu-empty">C4 - Nicaragua</li>
      </ul>
      
      
      <div className="topbar-profile">
        <button className="topbar-profile-button p-link" type="button"
         onClick={(e) => menuRight.current.toggle(e)}>
          <span className="profile-details">
            <span className="profile-name">{Auth.nombre}</span>
            {/* <span className="profile-job">Developer</span> */}
          </span>
          <i className="pi pi-angle-down"></i>
        </button>
          <Menu
          model={optionsUser}
          popup
          ref={menuRight}
          id="popup_menu_right"
          popupAlignment="right"
        />
        {/* Aquí podrías agregar menú desplegable si gustas */}
      </div>
    </div>
  );
};

export default Navbar;
